import React, { Component } from 'react';
import { Icon, Input } from '@tinper/next-ui'
import render from 'ynf-core-engine/render'
import _ from 'lodash';

import { getFieldId, awaitTo, getJsonObj, computedTagWidth } from '../utils/tools';
import { getShowValue, isDesigner, formatShowValueFromProps, loadShowValue, needInitLoadShowValue, formatProps, changeValue } from '../utils/formatter';
import referIndexDB from '../utils/cache';

import initRootStore from '../stores/referRootStore';
import ReferModel from './ReferModal/ReferModal';
import ReferSearch from './ReferSearch/ReferSearch';
import SmartSearch from './SmartSearch/SmartSearch';
import DropDown from './DropDown/DropDown';

import '../assests/index.less'

export default class ReferInputPc extends Component {
  constructor (props: any) {
    super(props)
    this.formatProps = formatProps(props)
    this.referRootStore = null

    this.state = {
      inputValue: '', // 参照本身搜索的值
      focused: false,
    }
    this.referRef = React.createRef();
  }

  async componentDidMount () {
    const { defaultOpen } = this.props;
    if (defaultOpen) {
      this.handleClick();
    }
    this.queryRefData(this.formatProps)
  }

  componentWillUpdate (nextProps: any, nextState: any) {
    if (!_.isEqual(this.props.value, nextProps.value)) { // 两次值不一样 证明值改变
      nextState.inputValue = ''
      // nextState.showModal = false
    }
  }

  componentWillReceiveProps (nextProps: any) {
    this.formatProps = formatProps(nextProps)
    this.queryRefData(nextProps)
  }

  queryRefData = (nextProps: any) => { // 默认加载数据
    const { isAutoShowName = true, multiple } = this.formatProps
    const val = changeValue(this.formatProps, this.props)

    if (isAutoShowName && needInitLoadShowValue(this.formatProps, val)) { // 多选的有些问题-先不做补充name逻辑
      loadShowValue(this.formatProps, (data: any) => {
        this.setState({ multipleValue: data })
      });
    }

    if (isAutoShowName && multiple && !_.isEqual(nextProps.value, this.props.value) && !nextProps.value?.length) {
      this.setState({ multipleValue: '' })
    }
  }

  getPrefixDom = () => { // 前缀和多选tag
    const { addonBefore, multiple } = this.formatProps;
    if (!multiple) { // 单选时只返回用户自定义前缀
      return <span className='refer-prefix'>{addonBefore}</span>
    }
    return (
      <div className='refer-tag-container'>
        {/* 用户自定义前缀 */}
        <span className='refer-prefix'>{addonBefore}</span>
        <div ref={(e) => { this.tagRef = e }} className='ynf-mul-tag'>
          {this.renderMulTagList()}
        </div>
      </div>
    );
  }

  getReferAfter = () => { // 后缀
    const { addonAfter } = this.props
    return addonAfter ? <span style={{ whiteSpace: 'nowrap' }}>{addonAfter}</span> : null
  }

  renderMulTagList = () => { // 渲染多选标签列表
    const value = this.state.multipleValue || this.props.value;
    const { readOnly } = this.props;
    if (!value || value.length === 0) return ''
    const tagContainerWidth = this.tagRef?.getBoundingClientRect().width ?? 0;
    const preWidth = this.targetInput?.input.getBoundingClientRect().width ?? 0;
    const containerWidth = tagContainerWidth === 0 ? preWidth - 16 : (tagContainerWidth + preWidth); // 容器宽度
    if (!containerWidth && !this.tagRef) {
      this.forceUpdate() // 容器没加载, 强制重新渲染
      return ''
    }
    const multiStr: string[] = [];
    value.forEach((element: any) => {
      multiStr.push(formatShowValueFromProps(this.props, element));
    });
    if (readOnly) {
      return <span className='ynf-mul-tag-browse' title={multiStr.join(',')}>{multiStr.join(',')}</span>;
    }

    let allTagWidth = 0; // 所有tag加起来的宽
    let count = value.length;
    const widthArr: any = [];
    // 计算单个tag所占宽度
    for (let i = 0; i < value.length; i++) {
      const text = formatShowValueFromProps(this.props, value[i])
      const tagWidth = computedTagWidth(text)
      allTagWidth += tagWidth;
      widthArr.push(tagWidth)
      if (allTagWidth > containerWidth) {
        count = i + 1;
        break;
      }
    }
    const showValue = value.slice(0, count);
    let isShowCount = false;
    // 计算合计tag所占宽度
    if (count < value.length || allTagWidth > containerWidth) {
      isShowCount = true;
      const noVisibleSpan = document.createElement('span');
      document.body.appendChild(noVisibleSpan);
      noVisibleSpan.innerHTML = `${lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_191B4C460520000E', '共', undefined, {returnDom: true, placement: 'top'})}${value.length}${lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_191B4C4605200010', '条', undefined, {returnDom: true, placement: 'top'})}`;
      noVisibleSpan.style.visibility = 'hidden';
      noVisibleSpan.style.position = 'fixed';
      noVisibleSpan.style.fontSize = '12px'
      allTagWidth += noVisibleSpan.getBoundingClientRect().width + 20;
    }
    // 去掉末尾tag直到不超出容器宽度
    while (allTagWidth > containerWidth) {
      allTagWidth -= widthArr.pop() + 20
      showValue.pop()
    }
    return (<>
      {
        showValue.map((item: any, index: any) => {
          return <span className='ynf-mul-tag-span' key={index}>
            {formatShowValueFromProps(this.props, item)}
            {!readOnly && <Icon type='uf-close' onClick={() => { this.deleteTag(index) }} fieldid={`${getFieldId(this.props)}_tag_close`} />}
          </span>
        })
      }
      { isShowCount ? <span title={multiStr.join(',')} className='ynf-mul-tag-span'>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_191B4C460520000E', '共', undefined, {returnDom: true, placement: 'top'})}{value.length}{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_191B4C4605200010', '条', undefined, {returnDom: true, placement: 'top'})}</span> : null }
    </>)
  }

  deleteTag = async (index: any) => { // 删除一条数据
    const { value, disabled, onChange } = this.props;
    if (disabled) return;
    const _value = _.cloneDeep(value);
    _value.splice(index, 1)
    if (this.referRootStore) {
      this.referRootStore.setData(_value)
    } else {
      onChange?.(_value)
    }
  }

  initReferStore = async (type: any) => {
    const { refCode, alias, message, refReturn } = this.formatProps
    if (!refCode || !refReturn) {
      const msg = !refCode && lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1BAEC6CC05D0001B', '未配置参照编码') || !refReturn && lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1BAEC6CC05D0001C', '未配置携带')
      message?.danger(msg);
      return false
    }
    this.formatProps = formatProps(this.props)

    // 用户自定义打开弹窗事件
    const flag = await (type === 'open' ? this.props.beforeOpen?.() : true)
    if (flag === false) return false;
    if (this.formatProps.tableStore) { // 判断不了是否是在子表--全当在子表里面
      !this.formatProps.tableStore.columnStore && (this.formatProps.tableStore.columnStore = {})
      if (this.formatProps.tableStore.columnStore[alias]) {
        this.referRootStore = this.formatProps.tableStore.columnStore[alias]
      }
    }

    if (this.referRootStore) {
      type === 'open' && this.referRootStore.openRefer()
      this.referRootStore.referInputProps = this.formatProps
      return this.referRootStore
    }
    if (this.referStorePromise) {
      return await this.referStorePromise;
    }

    this.referStorePromise = new Promise<any>(async (resolve) => {
      const [data] = await awaitTo(referIndexDB.getRefMeta(this.formatProps), undefined, this.formatProps);
      const [store] = await awaitTo(initRootStore(data, this.formatProps), undefined, this.formatProps)
      if (!store) {
        this.referStorePromise = null
        resolve(this.referRootStore);
        return
      }

      this.referRootStore = store
      this.referRootStore.referInput = this
      this.referRootStore.referInputProps = this.formatProps

      this.formatProps.tableStore && (this.formatProps.tableStore.columnStore[alias] = store)
      !this.formatProps.tableStore && this.formatProps.pageStore && (this.formatProps.pageStore[alias] = store)

      this.props.onStoreLoaded?.(store)

      type === 'open' && this.referRootStore.openRefer()
      resolve(this.referRootStore);
      this.forceUpdate()
    })
    return await this.referStorePromise;
  }

  handleFocus = async () => {
    try {
      const { subuiType } = this.formatProps
      const type = subuiType === 'drop' ? 'open' : 'init'
      await this.initReferStore(type)

      this.setState({ focused: true })
    } catch (error) {
      console.error('--参照获取焦点报错--', error);
    }
  }

  handleChange = (e: any) => {
    const { bSmartSearch, subuiType } = this.formatProps

    this.setState({ inputValue: e })
    if (e === '') {
      this.onClear(null)
    }
    if (bSmartSearch && subuiType !== 'drop' && this.referRootStore) {
      this.referRootStore.referStore.setValue('requestData.likeValue', e)
    }
  }

  handleBlur = async (val: any) => {
    const { textField, multiple, referValid, value, message, subuiType, bSmartSearch, valueField } = this.formatProps
    const text = multiple ? '' : value?.[textField]
    this.setState({ focused: false })
    if (!val || referValid === false || text === val || !this.referRootStore || this.isClick || subuiType === 'drop') return;

    let res = await this.referRootStore.getRefData({ params: { page: { pageIndex: 1, pageSize: 5 }, likeValue: val, path: undefined } })
    if (!res.length) {
      message?.danger(lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1BAEC6CC05D0001D', '无此条记录，请重新输入'))
    } else if (res.length === 1) {
      if (multiple) {
        const obj: any = {}
        res = [...this.props.value, ...res].reduce((acc, curr) => {
          if (!curr || obj[curr[valueField]]) return acc
          obj[curr[valueField]] = true
          return [...acc, curr]
        }, [])
      }
      this.referRootStore.setData(res)
    } else {
      !bSmartSearch && this.handleClick({ likeValue: val })
    }
  }

  onClear = async (e: any) => { // 清空
    e?.stopPropagation()
    e?.nativeEvent.stopImmediatePropagation()
    await this.props.onClear?.()
    this.setState({ inputValue: '' })
    if (this.referRootStore) {
      await this.referRootStore.setData([])
    } else {
      await this.props.onChange?.(this.formatProps.multiple ? [] : {})
    }
    this.targetInput.focus()
  }

  handleClick = async (opt: any = {}) => { // 参照点击
    const { disabled = false, rowStore } = this.formatProps;
    rowStore && (rowStore.tableStore.currentActiveRowKey = '')

    if (disabled) return null
    if (this.formatProps.subuiType === 'drop') {
      return this.targetInput.focus()
    }
    try {
      const res = await this.initReferStore('open')
      if (!res) return
      this.referRootStore.referStore.setValue('requestData.likeValue', opt.likeValue)
      this.referRootStore.searchData({ type: 'init', search: true })
      this.referRootStore.referStore.setValue('modalVisible', true)
    } catch (error) {
      console.error('--参照点击报错--', error);
    }
    this.isClick = false
  }

  handleMouseDown = () => {
    this.isClick = true
  }

  handleOk = async () => { // 弹窗确定
    this.referRootStore.handleOk()
  }

  handleClose = () => { // 关闭弹窗
    this.referRootStore.referStore.setValue('modalVisible', false)
    this.props.onClose?.();
  }

  handlePressEnter = (e: any) => {
    this.handleBlur(e.target.value)
  }

  renderInput = () => { // 输入框渲染
    let { refCode, refReturn, contentStyle, disabled, bordered = true, value, extraProps = {}, placeholder = lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00030', '请输入', undefined, {returnDom: true, placement: 'top'}), initPlaceholder, bCanHandleInput } = this.props
    const { multiple, subuiType } = this.formatProps
    const { inputValue } = this.state;
    const showValue = getShowValue(this.formatProps); // 显示值 ----这里只处理单选的情况-后续把多选的数据处理也在这里面处理

    const designStyle = isDesigner(this.formatProps) ? { pointerEvents: 'none' } : {} // 设计器态
    // 多选tag input前缀
    if (multiple && value && value.length > 0) placeholder = ''
    // input后缀
    const suffix = (<>
      {this.getReferAfter()}
      {((!placeholder || inputValue || showValue) && !disabled) && <Icon type='uf-close-c' className='refer-clear' onClick={(e: any) => { this.onClear(e) }} fieldid={`${getFieldId(this.props)}_input_close`} />}
      {
        subuiType === 'drop'
          ? <Icon type='uf-treearrow-down' className='refer-icon' onClick={() => this.handleClick()} onMouseDown={this.handleMouseDown} fieldid={`${getFieldId(this.props)}`} /> :
          <Icon type='uf-symlist' className='refer-icon' onClick={() => this.handleClick()} onMouseDown={this.handleMouseDown} fieldid={`${getFieldId(this.props)}`} />
      }
    </>)
    return (
      <div className= {refCode ? 'refer-input-pc-box' : 'refer-input-pc-box no-refcode'} ref={this.referRef} id={`${this.state.inputId}_container`}>
        <Input
          fieldid={getFieldId(this.props)}
          disabled={disabled}
          readOnly={bCanHandleInput === false}
          suffix={suffix}
          placeholder={(!refCode || !refReturn) ? (initPlaceholder || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A28FCC05C00031', '未设置参照', undefined, {returnDom: true, placement: 'top'})) : placeholder}
          value={inputValue || showValue}
          onChange={this.handleChange}
          ref={(e: any) => { this.targetInput = e }}
          autoFocus={extraProps.autoFocus}
          style={{ ...contentStyle, ...designStyle }}
          innerStyle={contentStyle}
          prefix={this.getPrefixDom()} // 多选tag input前缀------------这是多选的处理-后续统一走getShowValue
          bordered={bordered || 'bottom'}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onPressEnter={this.handlePressEnter}
          // allowClear={true} // 暂时不用
          id={this.state.inputId}
        />
      </div>
    )
  }

  renderModel = () => { // 弹窗渲染
    const { subuiType } = this.formatProps
    if (!this.referRootStore || subuiType === 'drop') return null

    return <ReferModel
      inputProps={this.formatProps}
      referRootStore={this.referRootStore}
      onOk={() => this.handleOk()}
      onCancel={() => this.handleClose()}
      // visible={showModal}
    >
      <div className='refer-model-body'>
        <ReferSearch inputProps={this.formatProps} referRootStore={this.referRootStore}/>
        {render(this.referRootStore.metaDataObj.gridMeta.nfwFeData.children.find((child: any) => child.controlType === 'BillTemplate'), { rootStore: this.referRootStore })}
      </div>
    </ReferModel>
  }

  renderPopover = () => { // 下拉方式渲染
    const { subuiType } = this.formatProps
    const { focused, inputValue } = this.state
    if (!this.referRootStore || subuiType !== 'drop') return null
    return <DropDown inputProps={this.formatProps} referRootStore={this.referRootStore} referRef={this.referRef} focused={focused} inputValue={inputValue} clearValue={() => this.setState({ inputValue: '' })}/>
  }

  renderSmartSearch = () => { // smartsearch
    const { bSmartSearch, readOnly, disabled } = this.formatProps
    const { inputValue } = this.state
    if (!this.referRootStore || !bSmartSearch || readOnly || disabled) return null
    return <div><SmartSearch inputProps={this.formatProps} referRootStore={this.referRootStore} referRef={this.referRef} inputValue={inputValue} clearValue={() => this.setState({ inputValue: '' })}/></div>
  }

  renderBrowse = () => { // 浏览态渲染
    let { value, contentStyle, multiple } = this.formatProps;
    const addonAfterDom = this.getReferAfter();
    const prefixDom = this.getPrefixDom(); // 多选时这里渲染值
    contentStyle = getJsonObj(contentStyle, {})

    let dom
    if (!multiple) { // 单选
      const showValue = getShowValue(this.formatProps);
      dom = <div style={contentStyle}>{(showValue || showValue === 0) ? [prefixDom, showValue, addonAfterDom] : '--'}</div>
    } else {
      dom = <div ref={(e) => { this.tagRef = e }} className='refer-tag-container'>
        {value?.length ? [prefixDom, addonAfterDom] : '--'}
      </div>
    }
    return <>{dom}{this.renderModel()}</>
  }

  render () {
    const { visible = true, readOnly = false } = this.props;
    if (!visible) return null
    if (!isDesigner(this.props) && readOnly) return this.renderBrowse()
    return (
      <div className='refer-container'>
        {this.renderInput()}
        {this.renderModel()}
        {this.renderPopover()}
        {this.renderSmartSearch()}
      </div>
    );
  }
}
